var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container item-price-side mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_c('div',{staticClass:"item"},[_c('h4',{staticClass:"price"},[_c('b',[_vm._v("0／"+_vm._s(_vm.data.number_of_slots))])])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"price"},[_c('b',[_vm._v("受付中／枠数")])])
}]

export { render, staticRenderFns }